// angular
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

// others
import { AppService } from '../../app.service';
import { ProfileService } from '../profile/profile.service';
import { AuthService } from '../../core/auth.service';
import * as _ from 'lodash';

@Component({
    selector: 'me-footer',
    templateUrl: './me-footer.component.html',
    styleUrls: ['./me-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ProfileService]
})

export class MeFooterComponent implements OnInit {
    data: any;
    languageLocale: string;
    language: any;
    languages = this.appService.meLanguages;
    url = 'navigation/footer';

    constructor(
        public appService: AppService,
        public profileService: ProfileService,
        public authService: AuthService,
        public translate: TranslateService
    ) {
    }

    ngOnInit() {
        this.languageLocale = this.appService.getLanguage() || this.translate.currentLang;
        this.getContent();
        this.translate.onLangChange.subscribe(value => {
            this.languageLocale = value['lang'];
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
        });
    }

    changeLanguage() {
        this.language = _.find(this.languages, {'locale': this.languageLocale});
        const patientId = this.authService.patientId;
        let data = {
            language_id: this.language.id
        };
        if(!patientId){
            this.appService.setLanguage(this.languageLocale);
            return;
        }
        this.appService.isLoading = true;
        this.profileService.patientId = patientId;
        this.profileService.updateProfile(data).subscribe(response => {
            this.appService.setLanguage(this.languageLocale);
            this.authService.setUserLanguage(this.language);
            location.reload();
        });
    }
}
